<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    export default {
        name: 'HelperMain'
    }
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    .el-menu {
        text-align: center;
    }

    .menu-aside {
        margin-top: 3rem;
        width: 160px !important;
    }

    .main-container {
        margin-left: 1rem;
    }

</style>
